import {
  Component,
  EventEmitter,
  Injectable,
  Input,
  OnInit,
  OnDestroy,
  Output,
  ViewChild,
  ElementRef,
  TemplateRef,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UploadService } from '../../../../common/services/Upload.service';
import { ConfirmationService } from 'primeng/primeng';
import { Location } from '@angular/common';
import { EvsProductService } from '../../../../common/services/EvsProduct.service';
import { CategoryService } from '../../../../common/services/Category.service';
import { IOption } from 'ng-select';
import { UtilityService } from '../../../../common/services/Utility.service';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { ImageService } from '../../../imageService';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';

declare var $: any;
var that: any;

@Component({
  moduleId: module.id,
  selector: 'evs_product_edit',
  templateUrl: './product_edit.component.html',
  styleUrls: ['./product.css'],
  providers: [ConfirmationService, EvsProductService],
})
@Injectable()
export class EvsProductEditComponent implements OnInit, OnDestroy {
  modalRef: BsModalRef;
  @Input('idDetail') idDetail: any;
  @Output('backToList') backToList = new EventEmitter();
  @ViewChild('uploadImageCke') uic: ElementRef;
  public productForm: FormGroup;
  public totalPage: number[] = [];
  public titleFile: string = 'Chọn file upload';
  public message: { class: string; content: string } = null;
  public error: string = '';
  public files: any = null;
  public componentData = null;
  public routerChange: any;
  public product: any = {};
  public detail: any;
  public product_id: number = 0;
  public events: any[] = [];
  public selectedCate: number = 0;
  public cateList: Array<any> = [];
  public cateList2: Array<any> = [];
  public cateList3: Array<any> = [];
  public messageErrorImage: string = '';
  public images: any[] = [];

  private attachments: any[] = [];
  public listImg: any[];
  public filesThumb: any;
  public thumb: string;
  isTrueSize: Boolean = true;

  vendors: any = [];
  vendor_id: any;
  idInfo: any = 0;
  currentNumberImage: any = 0;
  listIndexImage: any = [];
  listInfos: any = [];

  public venderUpdate: any = {};
  cities: any = [];
  districts: any = [];
  countries: Array<IOption> = [];
  selectedCountry: any;


  filesAttach: any = [];
  filesAttachFake: any = [];
  filesAttachName: any = [];
  filesAttachNameFake: any = [];

  isUpdateting: Boolean = false;
  is_use_time: Boolean = false;

  ckeConfig: any;
  source = Number(JSON.parse(localStorage.getItem('User')).source)

  public imagesVendor: any = {};

  is_txng_sync: boolean = false;

  isStandardGTIN(sku: string): boolean {
    if (!sku) return false;
    const len = sku.length;
    return len === 8 || len === 12 || len === 13 || len === 14;
  }

  langSubscription: Subscription;
  placeholders: any = {};
  currentLang: string = 'vi';

  constructor(
    private _location: Location,
    public productService: EvsProductService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    public upload: UploadService,
    private cate: CategoryService,
    private _fb: FormBuilder,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private evsAddressService: EvsAddressService,
    private imageService: ImageService,
    private translate: TranslateService
  ) {
    that = this;
  }

  showUpdateVendor(template: TemplateRef<any>) {
    if (this.vendor_id) {
      this.productService.loadVendorDetail(this.vendor_id).subscribe((res) => {
        if (res.data) {
          this.venderUpdate = res.data;
          this.imagesVendor.url = res.data.logo_url ? res.data.logo_url : null;
          this.imagesVendor.id = res.data.logo ? res.data.logo : null;
          if (this.venderUpdate.country_id) {
            this.selectedCountry = this.venderUpdate.country_id.toString();
          }
          this.getCountries();
          this.getCity();
          if (this.venderUpdate.city_id && this.selectedCountry === '241') {
            this.loadDistrictData(this.venderUpdate.city_id);
          }
          this.modalRef = this.modalService.show(template);
        } else {
          this.toastr.warning(
            'Không thể tải dữ liệu nhà sản xuất, vui lòng thử lại sau',
            '',
            {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            }
          );
        }
      });
    } else {
      this.toastr.warning('Phải lựa chọn nhà sản xuất', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
  }

  addImgVendorDistributor = (item: any, index: any) => {
    console.log(123123);
    const numberImages = item.target.files.length
    if (numberImages > 1) {
      this.toastr.error('Chỉ được upload tối đa 1 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    } else {
      const image = item.target.files;
      console.log(image);
      for (const image of item.target.files) {

        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = {
              id: res.data.fileId,
              url: res.data.url,
            };
            this.imagesVendor = image2
          }
        });



      }
    }
  }

  deleteImageVender() {
    // localStorage.removeItem('updateVendorProduct');
    this.imagesVendor.id = '';
    this.imagesVendor.url = null;
  }

  updateVendorData() {
    var dataUpdateVendor: any = {};
    if (!this.venderUpdate.name || this.venderUpdate.name == '') {
      this.toastr.warning('Tên nhà sản xuất không được để trống', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
    if (!this.venderUpdate.address || this.venderUpdate.address == '') {
      this.toastr.warning('Địa chỉ không được để trống', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }

    if (
      (this.venderUpdate.name &&
        this.venderUpdate.name !== '' &&
        this.venderUpdate.address) ||
      this.venderUpdate.address !== ''
    ) {
      dataUpdateVendor.name = this.venderUpdate.name;
      dataUpdateVendor.internal_name = this.venderUpdate.internal_name;
      if (this.selectedCountry) {
        dataUpdateVendor.country_id = parseInt(this.selectedCountry);
      }
      dataUpdateVendor.address = this.venderUpdate.address;
      if (this.venderUpdate.city_id) {
        dataUpdateVendor.city_id = parseInt(this.venderUpdate.city_id);
      }
      if (this.venderUpdate.district_id) {
        dataUpdateVendor.district_id = parseInt(this.venderUpdate.district_id);
      }
      if (this.selectedCountry !== '241') {
        dataUpdateVendor.city_id = null;
        dataUpdateVendor.district_id = null;
      }
      dataUpdateVendor.website = this.venderUpdate.website
        ? this.venderUpdate.website
        : '';
      dataUpdateVendor.description = this.venderUpdate.description
        ? this.venderUpdate.description
        : '';
      dataUpdateVendor.email = this.venderUpdate.email
        ? this.venderUpdate.email
        : '';
      dataUpdateVendor.phone = this.venderUpdate.phone
        ? this.venderUpdate.phone
        : '';
      dataUpdateVendor.gln_code = this.venderUpdate.gln_code ? this.venderUpdate.gln_code : '';
      // let imgStore = JSON.parse(localStorage.getItem("updateBusinessContact"));
      // if(imgStore){
      //   dataUpdateVendor.logo = imgStore.id
      // }else{
      //   dataUpdateVendor.logo = null;
      // }

      dataUpdateVendor.logo = this.imagesVendor.url ? this.imagesVendor.url : '';
      this.productService
        .updateVendorDetail(this.venderUpdate.id, dataUpdateVendor)
        .subscribe((res) => {
          if (res.error) {
            this.toastr.error('Cập nhật thất bại', res.message, {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            console.log(4444);

            this.toastr.info('Cập nhật thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.modalRef.hide();
          }
        },
          (error) => {
            console.log(12333333);
            this.toastr.error('Cập nhật thất bại', error.message, {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          });
    }
  }

  getCountries() {
    this.evsAddressService.getCountries().subscribe((res) => {
      let list: Array<any> = [];
      for (let _data of res.data.countries) {
        let obj = {
          value: _data.id.toString(),
          label: _data.name,
          image: _data.ensign,
        };
        list.push(obj);
      }
      this.countries = list;
    });
  }

  getCity() {
    if (this.selectedCountry === '241') {
      this.evsAddressService.getCities().subscribe((res) => {
        let citiesList = [];
        res.data.cities.forEach((c: any) => {
          citiesList.push({
            value: c.name,
            label: c.name,
            id: c.id,
          });
        });
        this.cities = citiesList;
        for (let i = 0; i < this.cities.length; i++) {
          if (this.cities[i].id === this.venderUpdate.city_id) {
            this.loadDistrictData(this.venderUpdate.city_id);
          }
        }
      });
    }
  }

  loadDistrictData(id: number) {
    this.evsAddressService
      .getDistrict({ city_id: id })
      .toPromise()
      .then((res) => {
        let districts = [];
        res.data.districts.forEach((c: any) => {
          districts.push({
            value: c.name,
            label: c.name,
            id: c.id,
          });
        });
        this.districts = districts;
      });
  }

  ngOnInit() {
    // if(JSON.parse(localStorage.getItem("updateVendorProduct"))){
    //   this.imagesVendor = JSON.parse(localStorage.getItem("updateVendorProduct"));
    // }

    this.currentLang = this.translate.currentLang || 'vi';
    this.updatePlaceholders();
    this.langSubscription = this.translate.onLangChange.subscribe((event: any) => {
      this.currentLang = event.lang;
      this.updatePlaceholders();
    });

    this.createForm();
    this.routerChange = this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.product_id = params['id'];
        this.attachments = [];
        this.getDetailProduct(this.idDetail);
      }
    );
    // this.getCountries();

    this.ckeConfig = {
      allowedContent: true,
      forcePasteAsPlainText: true,
      font_names: 'Arial;Times New Roman;Verdana',
      extraPlugins: 'iframe',
      toolbarGroups: [
        { name: 'document', groups: ['mode', 'document', 'doctools'] },
        { name: 'clipboard', groups: ['clipboard', 'undo'] },
        {
          name: 'editing',
          groups: ['find', 'selection', 'spellchecker', 'editing'],
        },
        { name: 'forms', groups: ['forms'] },
        '/',
        { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
        {
          name: 'paragraph',
          groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'],
        },
        { name: 'links', groups: ['links'] },
        { name: 'insert', groups: ['insert'] },
        '/',
        { name: 'styles', groups: ['styles'] },
        { name: 'colors', groups: ['colors'] },
        { name: 'tools', groups: ['tools'] },
        { name: 'others', groups: ['others'] },
        { name: 'about', groups: ['about'] },
      ],
      removeButtons:
        'Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Undo,Redo,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Strike,Subscript,Superscript,CopyFormatting,RemoveFormat,Outdent,Indent,CreateDiv,Blockquote,BidiLtr,BidiRtl,Language,Unlink,Anchor,Flash,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Maximize,ShowBlocks,About',
    };

    $('.cke_button__image').hide();

    // setTimeout(() => {
    //   $(".cke_button__image").hide();
    //   $(`.test${this.arrContent[0].id} .cke_button__link`)
    //     .parent()
    //     .append(
    //       `<a style="display: inline-block;padding: 4px;"><span class="cke_button_icon cke_button__image_icon" style="background-image:url('https://cdn.ckeditor.com/4.14.0/standard-all/plugins/icons.png?t=K24B');background-position:0 -1224px;background-size:auto;">&nbsp;</span></a>`
    //     );
    //   $(
    //     `.test${this.arrContent[0].id} .cke_button_icon.cke_button__image_icon`
    //   ).click((event) => {
    //     this.currentContentIndex = 0;
    //     this.modalRef = this.modalService.show(this.uic);
    //   });
    // }, 500);
  }

  addInfos(data: any) {
    this.idInfo++;
    let id = this.ramdomInfoID(this.idInfo);
    if (this.listInfos.indexOf(id) !== -1) {
      id = this.ramdomInfoID(this.idInfo);
    }
    var infomations = $('#productInfomations');
    if (data) {
      infomations.append(
        `<div id="` +
        'info' +
        id +
        `" class="form-horizontal p-10 pl-30 pr-30 mb-15" style="border: 1px solid #dcdcdc; position: relative;">
            <div class="form-group row">
              <label class="col-md-12">Tiêu đề: <span style="color: red;">(*) Tối đa 255 ký tự</span></label>
              <div class="col-md-12">
                <input id="` +
        'titleInfo' +
        id +
        `" type="text" class="form-control form-control-sm" placeholder="" value="` +
        data.title +
        `" autocomplete="off">
                <span id="` +
        'errorTitle' +
        id +
        `" style="color: red"></span>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-12">Nội dung: <span style="color: red;">(*)</span></label>
              <div class="col-md-12">
              <div id="` +
        'contentInfo' +
        id +
        `" style="height: 300px"></div>
              <span id="` +
        'errorContent' +
        id +
        `" style="position: absolute; bottom: 0px; color: red"></span>
              </div>
            </div>
            <i id="` +
        'close' +
        id +
        `" class="icon wb-close" style="position: absolute; top: 5px; right: 5px; cursor: pointer;"></i>
          </div>`
      );
      $('#' + 'contentInfo' + id).summernote('code', data.content);
      this.listInfos.push(id);
      $('#' + 'close' + id.toString()).click(function (res) {
        var index = parseInt(res.currentTarget.id.toString().split('close')[1]);
        for (let i = 0; i < that.listInfos.length; i++) {
          if (that.listInfos[i] == index) {
            $('#' + 'info' + index.toString()).remove();
            that.listInfos.splice(i, 1);
            that.idInfo--;
          }
        }
      });
      $('#' + 'titleInfo' + id.toString()).focusout(function () {
        if (
          $('#' + 'titleInfo' + id.toString()).val().length > 255 ||
          $('#' + 'titleInfo' + id.toString()).val().length == ''
        ) {
          $('#' + 'errorTitle' + id.toString()).text(
            'Tiêu đề tối thiểu là 1 ký tự và tối đa là 255 ký tự'
          );
        } else {
          $('#' + 'errorTitle' + id.toString()).text('');
        }
      });
      $('#' + 'contentInfo' + id)[0].parentNode.children[1].id = 'editor' + id;
      $('#' + 'editor' + id + ' .note-editing-area .note-editable').focusout(
        () => {
          if (
            $('#' + 'contentInfo' + id.toString()).summernote('code') ==
            '<p><br></p>' ||
            $('#' + 'contentInfo' + id.toString()).summernote('code').length ==
            ''
          ) {
            $('#' + 'errorContent' + id.toString()).text(
              'Nội dung không được để trống'
            );
          } else {
            $('#' + 'errorContent' + id.toString()).text('');
          }
        }
      );
    } else {
      infomations.append(
        `<div id="` +
        'info' +
        id +
        `" class="form-horizontal p-10 pl-30 pr-30 mb-15" style="border: 1px solid #dcdcdc; position: relative;">
        <div class="form-group row">
          <label class="col-md-12">Tiêu đề: <span style="color: red;">(*) Tối đa 255 ký tự</span></label>
          <div class="col-md-12">
            <input id="` +
        'titleInfo' +
        id +
        `" type="text" class="form-control form-control-sm" placeholder="" autocomplete="off">
            <span id="` +
        'errorTitle' +
        id +
        `" style="color: red"></span>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-12">Nội dung: <span style="color: red;">(*)</span></label>
          <div class="col-md-12">
            <div id="` +
        'contentInfo' +
        id +
        `" style="height: 300px"></div>
            <span id="` +
        'errorContent' +
        id +
        `" style="position: absolute; bottom: 0px; color: red"></span>
          </div>
        </div>
        <i id="` +
        'close' +
        id +
        `" class="icon wb-close" style="position: absolute; top: 5px; right: 5px; cursor: pointer;"></i>
      </div>`
      );
      $('#' + 'contentInfo' + id).summernote();
      this.listInfos.push(id);
      $('#' + 'close' + id.toString()).click(function (res) {
        var index = parseInt(res.currentTarget.id.toString().split('close')[1]);
        for (let i = 0; i < that.listInfos.length; i++) {
          if (that.listInfos[i] == index) {
            $('#' + 'info' + index.toString()).remove();
            that.listInfos.splice(i, 1);
            that.idInfo--;
          }
        }
      });
      $('#' + 'titleInfo' + id.toString()).focusout(function () {
        if (
          $('#' + 'titleInfo' + id.toString()).val().length > 255 ||
          $('#' + 'titleInfo' + id.toString()).val().length == ''
        ) {
          $('#' + 'errorTitle' + id.toString()).text(
            'Tiêu đề tối thiểu là 1 ký tự và tối đa là 255 ký tự'
          );
        } else {
          $('#' + 'errorTitle' + id.toString()).text('');
        }
      });
      $('#' + 'contentInfo' + id)[0].parentNode.children[1].id = 'editor' + id;
      $('#' + 'editor' + id + ' .note-editing-area .note-editable').focusout(
        () => {
          if (
            $('#' + 'contentInfo' + id.toString()).summernote('code') ==
            '<p><br></p>' ||
            $('#' + 'contentInfo' + id.toString()).summernote('code').length ==
            ''
          ) {
            $('#' + 'errorContent' + id.toString()).text(
              'Nội dung không được để trống'
            );
          } else {
            $('#' + 'errorContent' + id.toString()).text('');
          }
        }
      );
    }
    // $("#" + "info" + "1").remove();
    // console.log(infomations[0])
  }

  currentContentIndex: any = null;

  addInfos1() {
    const objectAdd = {
      id: new Date().getTime(),
      title: '',
      content: null,
      image: null
    };
    this.arrContent.push(objectAdd);
    setTimeout(() => {
      $('.cke_button__image').hide();
      $(`.test${objectAdd.id} .cke_button__link`)
        .parent()
        .append(
          `<a style="display: inline-block;padding: 4px;"><span class="cke_button_icon cke_button__image_icon" style="background-image:url('https://cdn.ckeditor.com/4.14.0/standard-all/plugins/icons.png?t=K24B');background-position:0 -1224px;background-size:auto;">&nbsp;</span></a>`
        );
      $(`.test${objectAdd.id} .cke_button_icon.cke_button__image_icon`).click(
        () => {
          let loca = this.arrContent.find((item) => item.id == objectAdd.id);
          if (loca) {
            this.currentContentIndex = this.arrContent.findIndex(
              (gg) => gg.id == loca.id
            );
          }
          this.modalRef = this.modalService.show(this.uic);
        }
      );
    }, 500);
  }

  ramdomInfoID(max) {
    return Math.floor(Math.random() * max + 1);
  }

  appendImageToShow(src) {
    let id = this.ramdomID();
    if (this.listIndexImage.indexOf(id) !== -1) {
      id = this.ramdomID();
    }
    this.currentNumberImage++;
    var listProductImage = $('#listProductImage');
    listProductImage.append(
      `<div id="` +
      'image' +
      id +
      `" style="float: left; position: relative" class="qr-item-image">
          <img id="` +
      'itemImg' +
      id +
      `" src="` +
      src +
      `" alt="" />
          <i id="` +
      'closeImg' +
      id +
      `" class="icon wb-close" style="position: absolute; top: 5px; right: 5px; cursor: pointer;"></i>
          </div>`
    );
    this.listIndexImage.push(id);
    $('#' + 'closeImg' + id.toString()).click(function (res) {
      var index = parseInt(
        res.currentTarget.id.toString().split('closeImg')[1]
      );
      for (let i = 0; i < that.listIndexImage.length; i++) {
        if (that.listIndexImage[i] == index) {
          $('#' + 'image' + index.toString()).remove();
          that.listIndexImage.splice(i, 1);
          that.img.splice(i, 1);
          that.currentNumberImage--;
        }
      }
    });
  }

  ramdomID() {
    return Math.floor(Math.random() * 100);
  }

  /*Function readUrlImagesUpload khong con dung nua*/
  readUrlImagesUpload(event: any) {
    var fileUpload: any = [];
    var files: any = [];
    files = event.srcElement.files;
    var ValidImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    if (this.currentNumberImage >= 20) {
      this.toastr.warning('Số lượng hình ảnh đã đạt tối đa', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      if (files.length > 0) {
        if (files.length < 20 - this.currentNumberImage) {
          for (let i = 0; i < files.length; i++) {
            if (files[i].size > 1024 * 1024) {
              this.toastr.error(
                'Kích thước hình ảnh ' +
                files[i].name +
                ' đã vượt quá 1MB, vui lòng chọn ảnh khác',
                '',
                {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                }
              );
            } else {
              if ($.inArray(files[i].type, ValidImageTypes) > 0) {
                fileUpload.push(files[i]);
              } else {
                this.toastr.error(
                  'Định dạng hình ảnh không phù hợp, vui lòng chọn ảnh khác',
                  '',
                  {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right',
                  }
                );
                return;
              }
            }
          }
        } else {
          for (let i = 0; i < 20 - this.currentNumberImage; i++) {
            if (files[i].size > 1024 * 1024) {
              this.toastr.error(
                'Kích thước hình ảnh ' +
                files[i].name +
                ' đã vượt quá 1MB, vui lòng chọn ảnh khác',
                '',
                {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                }
              );
            } else {
              if ($.inArray(files[i].type, ValidImageTypes) > 0) {
                fileUpload.push(files[i]);
              } else {
                this.toastr.error(
                  'Định dạng hình ảnh không phù hợp, vui lòng chọn ảnh khác',
                  '',
                  {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right',
                  }
                );
                return;
              }
            }
          }
        }

        Promise.all(
          fileUpload.map((file) => {
            return this.upload.upload(file).then((uploaded: any) => {
              return JSON.parse(uploaded._body).data;
            });
          })
        ).then((upload: any) => {
          upload.forEach((dta) => {
            this.appendImageToShow(dta.url);
            this.img.push(dta.url);
          });
        });
      }
    }
  }

  /*Ham them anh vao mang*/
  tusUpload = (item) => {
    const numberImages = item.target.files.length;
    console.log('numberImages', numberImages)
    console.log('this.img', this.img.length)
    if ((numberImages + this.img.length) > 5) {
      this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {

        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = {
              id: res.data.fileId,
              url: res.data.url,
            };
            if (this.images.length >= 5) {
              this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.img.push(image2);
              this.appendImageToShow(image2.url);
            }
          }
        });

      }
    }
  };

  ckeContent = [];
  imgUploadCke = (item) => {
    const numberImages = item.target.files.length;
    if (numberImages > 20) {
      this.toastr.error('Chỉ được upload tối đa 20 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {

        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = {
              id: res.data.fileId,
              url: res.data.url,
            };
            this.arrContent[
              this.currentContentIndex
            ].content += `<img src="${image2.url}">`;
          }
        });


      }
      this.modalRef.hide();
    }
  };

  ckeImageUrl: string = '';

  addCkeImageUrl() {
    if (this.ckeImageUrl) {
      this.arrContent[
        this.currentContentIndex
      ].content += `<img src="${this.ckeImageUrl}">`;
      this.ckeImageUrl = '';
    }
    this.modalRef.hide();
  }

  deleteIcon(index: number) {
    this.arrContent[index].image = null;
  }

  tusUploadIcon = (item: any, index: any) => {
    const numberImages = item.target.files.length;
    if (numberImages > 1) {
      this.toastr.error('Chỉ được upload tối đa 1 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {

        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = {
              id: res.data.fileId,
              url: res.data.url,
            };
            this.arrContent[index].image = image2.url;

          }
        });



      }
    }
  };

  img: any = [];
  arrContent: any = [];

  getDetailProduct(id) {
    this.productService
      .getDetaiById(id)
      .toPromise()
      .then(
        (res) => {
          if (res) {
            if (!res.error) {
              this.product = res.data;
              this.is_txng_sync = (this.product.source_tag === 'txng_sync') || true; // MOCK for UI view
              console.log('res.data.images11', res.data.images)
              this.img = res.data.images.filter((data) => {
                return data != '';
              });

              this.getAttachments();
              this.getAttachmentsFake();
              this.currentNumberImage = 0;
              this.idInfo = 0;
              if (this.product.images) {
                for (let i = 0; i < this.product.images.length; i++) {
                  this.appendImageToShow(this.product.images[i].small);
                }
              }

              // Map warranty_reminder_config to flat variables
              const mapModeReverse = (mode: string) => mode === 'ONCE' ? 'once' : 'recurring';
              const mapUnitReverse = (unit: string) => unit === 'DAY' ? 'days' : (unit === 'MONTH' ? 'months' : 'years');

              if (this.product.warranty_reminder_config) {
                const config = this.product.warranty_reminder_config;
                if (config.reminderMaintain && config.reminderMaintain.isSelect) {
                  this.product.is_maintenance_reminder = true;
                  this.product.maintenance_mode = mapModeReverse(config.reminderMaintain.mode);
                  this.product.is_extend_maintenance = config.reminderMaintain.reminderContinue || false;
                  this.product.maintenance_cycle = config.reminderMaintain.numberTimeNotify;
                  this.product.maintenance_cycle_unit = mapUnitReverse(config.reminderMaintain.timeType);
                  this.product.extend_limit = config.reminderMaintain.numberOfLimit || null;
                } else {
                  this.product.is_maintenance_reminder = false;
                }

                if (config.reminderExpired && config.reminderExpired.isSelect) {
                  this.product.is_expired_reminder = true;
                  this.product.expired_mode = mapModeReverse(config.reminderExpired.mode);
                  this.product.expired_cycle = config.reminderExpired.numberTimeNotify;
                  this.product.expired_cycle_unit = mapUnitReverse(config.reminderExpired.timeType);
                } else {
                  this.product.is_expired_reminder = false;
                }
              }

              //Convert string
              this.product.infos.map(val => {
                if (val.content.indexOf('<p>') === -1 && val.content.indexOf('\n') !== -1) {
                  val.content = '<p>' + val.content;
                  val.content = val.content.replace(/\n/g, '</p>\n<p>')
                }
              });

              if (this.product.infos) {
                for (let i = 0; i < this.product.infos.length; i++) {
                  let objectAdd = {
                    id: i.toString() + new Date().getTime(),
                    title: this.product.infos[i].title,
                    content: this.product.infos[i].content,
                    image: this.product.infos[i].image
                  };
                  this.arrContent.push(objectAdd);

                  setTimeout(() => {
                    $('.cke_button__image').hide();
                    $(`.test${objectAdd.id} .cke_button__link`)
                      .parent()
                      .append(
                        `<a style="display: inline-block;padding: 4px;"><span class="cke_button_icon cke_button__image_icon" style="background-image:url('https://cdn.ckeditor.com/4.14.0/standard-all/plugins/icons.png?t=K24B');background-position:0 -1224px;background-size:auto;">&nbsp;</span></a>`
                      );
                    $(
                      `.test${objectAdd.id} .cke_button_icon.cke_button__image_icon`
                    ).click(() => {
                      let loca = this.arrContent.find(
                        (item) => item.id == objectAdd.id
                      );
                      if (loca) {
                        this.currentContentIndex = this.arrContent.findIndex(
                          (gg) => gg.id == loca.id
                        );
                      }
                      this.modalRef = this.modalService.show(this.uic);
                    });
                  }, 500);
                  // this.addInfos(this.product.infos[i]);
                }
              }
              console.log('klaasa', this.product)
              this.productService.loadListVendor(undefined).subscribe((res) => {
                this.vendors = res.data;
                if (this.product.vendor) {
                  this.vendor_id = this.product.vendor.id;
                }

                for (let i = 0; i < this.vendors.length; i++) {
                  if (this.vendors[i].name.length >= 50) {
                    this.vendors[i].name =
                      this.vendors[i].name.slice(0, 50) + ' ...';
                  }
                }
              });
              this.productForm.reset();
              (<FormControl>this.productForm.controls['sku']).setValue(
                this.product.sku
              );
              (<FormControl>this.productForm.controls['name']).setValue(
                 this.product.display_name
              );
              (<FormControl>this.productForm.controls['internal_name']).setValue(
                // this.product.internal_name
                this.product.name
              );
              console.log("tuannguyenhung", this.productForm.value)
              if (this.product.use_time_count) {
                this.is_use_time = true;
                (<FormControl>(
                  this.productForm.controls['is_use_time']
                )).setValue(true);
              } else {
                (<FormControl>(
                  this.productForm.controls['is_use_time']
                )).setValue(false);
              }
              (<FormControl>(
                this.productForm.controls['use_time_count']
              )).setValue(this.product.use_time_count);
              (<FormControl>(
                this.productForm.controls['use_time_type']
              )).setValue(this.product.use_time_type);
              (<FormControl>this.productForm.controls['price']).setValue(
                this.product.price
              );
              (<FormControl>this.productForm.controls['is_maintenance_reminder']).setValue(
                this.product.is_maintenance_reminder || false
              );
              (<FormControl>this.productForm.controls['is_extend_maintenance']).setValue(
                this.product.is_extend_maintenance || false
              );
              (<FormControl>this.productForm.controls['maintenance_mode']).setValue(
                this.product.maintenance_mode || 'once'
              );
              (<FormControl>this.productForm.controls['maintenance_cycle']).setValue(
                this.product.maintenance_cycle
              );
              (<FormControl>this.productForm.controls['maintenance_cycle_unit']).setValue(
                this.product.maintenance_cycle_unit || 'months'
              );
              (<FormControl>this.productForm.controls['is_expired_reminder']).setValue(
                this.product.is_expired_reminder || false
              );
              (<FormControl>this.productForm.controls['expired_mode']).setValue(
                this.product.expired_mode || 'once'
              );
              (<FormControl>this.productForm.controls['expired_cycle']).setValue(
                this.product.expired_cycle
              );
              (<FormControl>this.productForm.controls['expired_cycle_unit']).setValue(
                this.product.expired_cycle_unit || 'months'
              );
              (<FormControl>this.productForm.controls['extend_limit']).setValue(
                this.product.extend_limit
              );
              (<FormControl>this.productForm.controls['video']).setValue(
                this.product.video
              );
              (<FormControl>this.productForm.controls['vendor']).setValue(
                this.product.vendor
              );
              (<FormControl>this.productForm.controls['status']).setValue(
                this.product.status ? '1' : '0'
              );
              (<FormControl>(
                this.productForm.controls['description']
              )).setValue(this.product.description, { onlySelf: false });
              if (!this.product.vendor) {
                // $('#vendor').removeAttr("disabled");
              } else {
                // $('#vendor').attr("disabled", "disabled");
                (<FormControl>this.productForm.controls['vendor']).setValue(
                  this.product.vendor
                );
              }
              // get list category
              // this.cate
              //   .all()
              //   .toPromise()
              //   .then((cate) => {
              //     let cateList = [];
              //     cate.forEach((c: any) => {
              //       cateList.push({
              //         value: c.id + '',
              //         label: c.name,
              //       });
              //     });
              //     this.cateList = cateList;
              //   });

              if (this.product.image) {
                this.thumb = UtilityService.getImg(this.product.image.small);
                $('#previewThumb').html('');
                $('#previewThumb').append(
                  '<li><div class="card card-shadow"><figure class="card-img-top overlay-hover overlay"><img class="overlay-figure overlay-scale" src="' +
                  this.thumb +
                  '" style="height: 100px;object-fit: cover;"></figure></div></li>'
                );
              }

              this.attachments = [];
              if (this.product.images) {
                this.product.images.forEach((att) => {
                  this.attachments.push(att.url);
                });
              }
              $('#previewImage').html('');
              let h = 0;
              this.attachments.forEach((atta) => {
                var idDiv = 'previewImage' + h;

                $('#previewImage').append(
                  '<li><div id="' +
                  idDiv +
                  '" class="card card-shadow"><figure class="card-img-top overlay-hover overlay"><img class="overlay-figure overlay-scale" src="' +
                  atta +
                  '" alt="..." style="height: 100px; width: 150px; object-fit: cover;"></figure><i id="' +
                  idDiv +
                  atta +
                  '" class="wb-close" style="position: absolute; top: 5px; right: 5px; color: red; font-weight: 400"></i></div></li>'
                );
                h++;
              });
              $('#previewImage').on('click', '.wb-close', function (e) {
                for (let i = 0; i < that.attachments.length; i++) {
                  var idIcon = e.currentTarget.id
                    .toString()
                    .split('previewImage' + i)[1];
                  if (idIcon === that.attachments[i]) {
                    $('#' + 'previewImage' + i + '').remove();
                    delete that.attachments[i];
                  }
                }
              });
            } else {
              this.message = {
                class: 'alert dark alert-danger',
                content: 'Error: ' + res.message,
              };
            }
          }
        },
        (error) => {
          this.message = {
            class: 'alert dark alert-danger',
            content: 'Error: ' + error,
          };
        }
      );
  }

  onDeselected(item, type) {
    if (type === 1) {
      this.cateList2 = [];
      this.cateList3 = [];
      (<FormControl>this.productForm.controls['cate_id1']).setValue(null, {
        onlySelf: true,
      });
      (<FormControl>this.productForm.controls['cate_id2']).setValue(null, {
        onlySelf: true,
      });
    } else if (type === 2) {
      this.cateList3 = [];
      (<FormControl>this.productForm.controls['cate_id2']).setValue(null, {
        onlySelf: true,
      });
    }
  }

  loadCateList(val, mode) {
    // this.cate
    //   .all({parent_id: val.value})
    //   .toPromise()
    //   .then((cate) => {
    //     let cat1 = cate[0];
    //     let cateList = [];
    //     cate.forEach((cat) => {
    //       cateList.push({
    //         value: cat.id,
    //         label: cat.name,
    //       });
    //     });
    //     if (mode == 2) {
    //       this.cateList2 = cateList;
    //       this.cateList3 = [];
    //       (<FormControl>this.productForm.controls['cate_id1']).setValue(null, {
    //         onlySelf: true,
    //       });
    //       (<FormControl>this.productForm.controls['cate_id2']).setValue(null, {
    //         onlySelf: true,
    //       });
    //     } else if (mode == 3) {
    //       this.cateList3 = cateList;
    //     } else {
    //       this.cateList = cateList;
    //     }
    //   });
  }

  createForm() {
    let isDisabled = this.source === 2 || this.is_txng_sync;
    this.productForm = this._fb.group({
      sku: [{ value: null, disabled: isDisabled }, [Validators.required]],
      name: [{ value: null, disabled: this.is_txng_sync }, [Validators.required]],
      price: [null],
      internal_name: [null],
      video: [{ value: null, disabled: this.source === 2 }],
      vendor: [{ value: null, disabled: isDisabled }],
      status: [{ value: '1', disabled: this.source === 2 }],
      description: [{ value: '', disabled: this.source === 2 }],
      is_use_time: [{ value: true, disabled: this.source === 2 }],
      use_time_type: [{ value: null, disabled: this.source === 2 }],
      use_time_count: [{ value: null, disabled: this.source === 2 }],
      is_maintenance_reminder: [{ value: false, disabled: this.source === 2 }],
      is_extend_maintenance: [{ value: false, disabled: this.source === 2 }],
      maintenance_mode: [{ value: 'once', disabled: this.source === 2 }],
      maintenance_cycle: [{ value: null, disabled: this.source === 2 }],
      maintenance_cycle_unit: [{ value: 'months', disabled: this.source === 2 }],
      warranty_reminder_config: [{ value: null, disabled: this.source === 2 }],
      is_expired_reminder: [{ value: false, disabled: this.source === 2 }],
      expired_mode: [{ value: 'once', disabled: this.source === 2 }],
      expired_cycle: [{ value: null, disabled: this.source === 2 }],
      expired_cycle_unit: [{ value: 'months', disabled: this.source === 2 }],
      extend_limit: [{ value: null, disabled: this.source === 2 }]
    });
  }

  backToComponent() {
    //this._location.back();
    this.backToList.emit({
      isBack: true,
    });
  }

  processSave() {
    this.message = {
      class: 'alert dark alert-info',
      content: 'Đang thực thi...',
    };
  }

  async onSubmit() {
    const data = this.productForm.getRawValue();

    if (data.is_maintenance_reminder) {
      if (!data.maintenance_cycle || parseInt(data.maintenance_cycle, 10) <= 0) {
        this.toastr.warning('Vui lòng nhập thời gian thông báo bảo trì lớn hơn 0', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        this.isUpdateting = false;
        return;
      }
    }

    if (data.is_expired_reminder) {
      if (!data.expired_cycle || parseInt(data.expired_cycle, 10) <= 0) {
        this.toastr.warning('Vui lòng nhập thời gian thông báo hết hạn bảo hành lớn hơn 0', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        this.isUpdateting = false;
        return;
      }
    }

    if (data.is_extend_maintenance && data.maintenance_mode === 'recurring') {
      if (!data.extend_limit || parseInt(data.extend_limit) <= 0) {
        this.toastr.warning('Vui lòng nhập giới hạn số lần gửi sau khi hết hạn BH lớn hơn 0', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        this.isUpdateting = false;
        return;
      }
    }

    this.isUpdateting = true;
    setTimeout(() => {
      this.isUpdateting = false;
    }, 2000);
    var productInfo: any = {};
    var images: any = [];
    var infos: any = [];
    for (let i = 0; i < this.listIndexImage.length; i++) {
      var img = $('#' + 'itemImg' + this.listIndexImage[i].toString()).attr(
        'src'
      );
      images.push(this.imageService.getFrefixFromUrl(img));
      console.log('images', images)
    }

    console.log('this.img1', this.img)

    let imageIds = [];
    this.img.forEach((element) => {
      imageIds.push(element.medium ? element.medium : element.url);
    });
    // console.log('this.listIndexImage', this.img)
    // console.log('this.listIndexImage22', imageIds)
    // return
    productInfo.images = imageIds;
    let hasWrongTitle: number = 0;
    let hasWrongContent: number = 0;
    // for (let i = 0; i < this.listInfos.length; i++) {
    //   let info: any = {};
    //   info.title = $("#" + "titleInfo" + this.listInfos[i].toString()).val();
    //   info.content = $(
    //     "#" + "contentInfo" + this.listInfos[i].toString()
    //   ).summernote("code");
    //   if (info.title.length > 255 || info.title == "") {
    //     hasWrongTitle++;
    //     $("#" + "errorTitle" + this.listInfos[i].toString()).text(
    //       "Tiêu đề tối thiểu là 1 ký tự và tối đa là 255 ký tự"
    //     );
    //   }
    //   if (info.content == "<p><br></p>" || info.content == "") {
    //     hasWrongContent++;
    //     $("#" + "errorContent" + this.listInfos[i].toString()).text(
    //       "Nội dung không được để trống"
    //     );
    //   }
    //   if (
    //     info.title != "" &&
    //     info.title.length <= 255 &&
    //     info.content != "<p><br></p>" &&
    //     info.content != ""
    //   )
    //     infos.push(info);
    // }
    // if (hasWrongTitle > 0 || hasWrongContent > 0) {
    //   this.toastr.warning("Thông tin chi tiết sản phẩm không hợp lệ", "", {
    //     timeOut: 4000,
    //     positionClass: "toast-bottom-right",
    //   });
    // }
    // productInfo.infos = infos;
    /*tam thoi bo required image */
    // if (productInfo.images.length < 1) {
    //   this.toastr.error("Hình ảnh tối tiểu phải là 1", "", {
    //     timeOut: 4000,
    //     positionClass: "toast-bottom-right"
    //   });
    // } else {
    //   if (data.sku !== "") productInfo.sku = data.sku;
    //   productInfo.name = data.name;
    //   if (!data.price || data.price == "") {
    //     productInfo.price = 0;
    //   } else {
    //     productInfo.price = parseInt(data.price);
    //   }
    //   if (data.video) {
    //     productInfo.video = data.video;
    //   }
    //   productInfo.vendor_id = this.vendor_id;
    //   productInfo.status = data.status;
    //   if (productInfo.name == "") {
    //     this.toastr.warning("Tên sản phẩm không được để trống", "", {
    //       timeOut: 4000,
    //       positionClass: "toast-bottom-right"
    //     });
    //   }
    //   if (productInfo.name.length > 100) {
    //     this.toastr.warning("Tên sản phẩm quá dài", "", {
    //       timeOut: 4000,
    //       positionClass: "toast-bottom-right"
    //     });
    //   }
    //   if (
    //     productInfo.name != "" &&
    //     productInfo.name.length <= 100 &&
    //     hasWrongTitle == 0 &&
    //     hasWrongContent == 0
    //   ) {
    //     if (this.filesAttach.length > 0) {
    //       Promise.all(
    //         this.filesAttach.map(attach => {
    //           return this.upload
    //             .uploadFileAttach(attach)
    //             .then((attached: any) => {
    //               return attached;
    //             });
    //         })
    //       ).then(attached => {
    //         var attach: any = [];
    //         attach = attached;
    //         productInfo.attachments = [];
    //         if (this.filesAttachName.length > 0) {
    //           for (let i = 0; i < this.filesAttachName.length; i++) {
    //             if (this.filesAttachName[i].isAdd == false) {
    //               productInfo.attachments.push(this.filesAttachName[i].link);
    //             }
    //           }
    //         }
    //         if (attach.length > 0) {
    //           if (this.product.approved_file == 1) {
    //             productInfo.approved_file = 2;
    //           }
    //           attach.forEach(att => {
    //             productInfo.attachments.push(att.url);
    //           });
    //         }
    //         this.productService
    //           .updateProductById(this.product.id, productInfo)
    //           .subscribe(res => {
    //             if (res.error) {
    //               this.toastr.error("Cập nhật sản phẩm thất bại", res.message, {
    //                 timeOut: 4000,
    //                 positionClass: "toast-bottom-right"
    //               });
    //             } else {
    //               this.toastr.success("Cập nhật sản phẩm thành công", "", {
    //                 timeOut: 4000,
    //                 positionClass: "toast-bottom-right"
    //               });
    //               this.backToList.emit({
    //                 isBack: false
    //               });
    //             }
    //           });
    //       });
    //     } else {
    //       productInfo.attachments = [];
    //       if (this.filesAttachName.length > 0) {
    //         for (let i = 0; i < this.filesAttachName.length; i++) {
    //           if (this.filesAttachName[i].isAdd == false) {
    //             productInfo.attachments.push(this.filesAttachName[i].link);
    //           }
    //         }
    //       }
    //       this.productService
    //         .updateProductById(this.product.id, productInfo)
    //         .subscribe(res => {
    //           if (res.error) {
    //             this.toastr.error("Cập nhật sản phẩm thất bại", res.message, {
    //               timeOut: 4000,
    //               positionClass: "toast-bottom-right"
    //             });
    //           } else {
    //             this.toastr.success("Cập nhật sản phẩm thành công", "", {
    //               timeOut: 4000,
    //               positionClass: "toast-bottom-right"
    //             });
    //             this.backToList.emit({
    //               isBack: false
    //             });
    //           }
    //         });
    //     }
    //   }
    // }

    if (this.arrContent) {
      let tmpInfo = [];
      this.arrContent.forEach((item, index) => {
        if (item.title == '' || item.title.length > 255) {
          hasWrongTitle++;
          $(`.form-group#${index} .text-danger-alert`).text(
            'Tiêu đề tối thiểu là 1 ký tự và tối đa là 255 ký tự'
          );
        } else {
          $(`.form-group#${index} .text-danger-alert`).text('');
        }

        if (item.content == '<p><br></p>' || item.content == '') {
          $(`.text-danger-cke-${index}`).text('Nội dung không được để trống');
          hasWrongContent++;
        } else {
          $(`.text-danger-cke-${index}`).text('');
        }

        if (
          item.title &&
          item.title.length <= 255 &&
          item.content != '<p><br></p>' &&
          item.content != ''
        ) {
          tmpInfo.push({
            title: item.title,
            content: item.content,
            image: item.image
          });
        }
      });

      if (tmpInfo) {
        productInfo.infos = tmpInfo;
      }
    }

    if (data.sku !== '') {
      productInfo.sku = data.sku;
    }
    console.log('data', data)
    productInfo.name = data.name;

    if (
      data.internal_name &&
      data.internal_name.trim() !== ''
    ) {
      productInfo.internal_name = data.internal_name.trim();
    }

    if (!this.is_use_time) {
      data.use_time_type = null;
      data.use_time_count = null;
    }
    productInfo.use_time_count = data.use_time_count;
    productInfo.use_time_type = data.use_time_type;

    const mapMode = (mode: string) => mode === 'once' ? 'ONCE' : 'REPEAT';
    const mapUnit = (unit: string) => unit === 'days' ? 'DAY' : (unit === 'months' ? 'MONTH' : 'YEAR');

    let warranty_reminder_config: any = {};

    if (this.productForm.value.is_maintenance_reminder) {
      warranty_reminder_config.reminderMaintain = {
        isSelect: true,
        mode: mapMode(this.productForm.value.maintenance_mode),
        reminderContinue: this.productForm.value.is_extend_maintenance,
        numberTimeNotify: this.productForm.value.maintenance_cycle ? parseInt(this.productForm.value.maintenance_cycle, 10) : null,
        timeType: mapUnit(this.productForm.value.maintenance_cycle_unit)
      };
      if (this.productForm.value.maintenance_mode !== 'once' && this.productForm.value.is_extend_maintenance && this.productForm.value.extend_limit) {
        warranty_reminder_config.reminderMaintain.numberOfLimit = parseInt(this.productForm.value.extend_limit, 10);
      }
    } else {
      warranty_reminder_config.reminderMaintain = { isSelect: false };
    }

    if (this.productForm.value.is_expired_reminder) {
      warranty_reminder_config.reminderExpired = {
        isSelect: true,
        mode: mapMode(this.productForm.value.expired_mode),
        reminderContinue: false,
        numberTimeNotify: this.productForm.value.expired_cycle ? parseInt(this.productForm.value.expired_cycle, 10) : null,
        timeType: mapUnit(this.productForm.value.expired_cycle_unit),
        numberOfLimit: 1
      };
    } else {
      warranty_reminder_config.reminderExpired = { isSelect: false };
    }

    productInfo.warranty_reminder_config = warranty_reminder_config;

    if (!data.price || data.price == '') {
      productInfo.price = null;
    } else {
      productInfo.price = parseInt(data.price);
    }
    if (data.video) {
      productInfo.video = data.video;
    }
    productInfo.vendor_id = this.vendor_id;
    productInfo.status = data.status;
    if (this.source !== 2) {
      if (productInfo.name == '') {
        this.toastr.warning('Tên sản phẩm không được để trống', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
      if (productInfo.name.length > 100) {
        this.toastr.warning('Tên sản phẩm quá dài', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    }

    if (
      ((productInfo.name && productInfo.name != '' && productInfo.name.length <= 100) || this.source === 2) &&
      hasWrongTitle == 0 &&
      hasWrongContent == 0
    ) {
      if (this.filesAttach.length > 0 || this.filesAttachFake.length > 0) {


        const dataFile = await this.uploadFiles()

        if (this.filesAttach.length > 0) {
          productInfo.attachments = [];
          if (this.filesAttachName.length > 0) {
            for (let i = 0; i < this.filesAttachName.length; i++) {
              if (this.filesAttachName[i].isAdd == false) {
                productInfo.attachments.push(this.filesAttachName[i].link);
              }
            }
          }
          if (dataFile.attach.length > 0) {
            if (this.product.approved_file == 1 || this.product.approved_file == 3) {
              productInfo.approved_file = 2;
            }
            dataFile.attach.forEach((att) => {
              productInfo.attachments.push(att.url);
            });
          }
        } else {
          productInfo.attachments = this.product.attachments
        }

        if (this.filesAttachFake.length > 0) {

          productInfo.fake_attachments = [];
          if (this.filesAttachNameFake.length > 0) {
            for (let i = 0; i < this.filesAttachNameFake.length; i++) {
              if (this.filesAttachNameFake[i].isAdd == false) {
                productInfo.fake_attachments.push(this.filesAttachNameFake[i].link);
              }
            }
          }
          if (dataFile.attachFake.length > 0) {
            if (this.product.approved_file == 1 || this.product.approved_file == 3) {
              productInfo.approved_file = 2;
            }
            dataFile.attachFake.forEach((att) => {
              productInfo.fake_attachments.push(att.url);
            });
          }
        } else {
          productInfo.fake_attachments = this.product.fake_attachments
        }

        console.log(33333333333, this.product)

        this.productService
          .updateProductById(this.product.id, productInfo)
          .subscribe((res) => {

            if (res.error) {

              this.toastr.error('Cập nhật sản phẩm thất bại', res.message, {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.toastr.success('Cập nhật sản phẩm thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.backToList.emit({
                isBack: false,
              });
            }
          }, err => {
            this.toastr.error('Cập nhật sản phẩm thất bại', err.message, {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          });
      } else {
        productInfo.attachments = [];
        if (this.filesAttachName.length > 0) {
          for (let i = 0; i < this.filesAttachName.length; i++) {
            if (this.filesAttachName[i].isAdd == false) {
              productInfo.attachments.push(this.filesAttachName[i].link);
            }
          }
        }

        productInfo.fake_attachments = [];
        if (this.filesAttachNameFake.length > 0) {
          for (let i = 0; i < this.filesAttachNameFake.length; i++) {
            if (this.filesAttachNameFake[i].isAdd == false) {
              productInfo.fake_attachments.push(this.filesAttachNameFake[i].link);
            }
          }
        }
        console.log(2222222222)

        this.productService
          .updateProductById(this.product.id, productInfo)
          .subscribe((res) => {

            if (res.error) {
              this.toastr.error('Cập nhật sản phẩm thất bại', res.message, {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.toastr.success('Cập nhật sản phẩm thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.backToList.emit({
                isBack: false,
              });
            }
          }, err => {
            this.toastr.error('Cập nhật sản phẩm thất bại', err.message, {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          });
      }
    }
    // console.log(this.listIndexImage);
    //console.log(this.product);
    // this.scrollToTop();
    // this.processSave();
    // this.listImg = [];

    // if (!data.price) {
    //     delete data.price
    // }
    // if (this.isTrueSize == true) {
    //     if (this.files && this.files.length > 0 || this.filesThumb) {
    //         if (this.files && this.files.length > 0) {
    //             this.listImg = this.files;
    //         }
    //         if (this.filesThumb) {
    //             if (this.files && this.files.length > 0) {
    //                 this.files.unshift(this.filesThumb);
    //             } else if (this.filesThumb) {
    //                 this.listImg.push(this.filesThumb);
    //             }
    //         }
    //         Promise.all(this.listImg.map(file => {
    //             return this.upload.upload(file).then(
    //                 (uploaded: any) => {
    //                     return uploaded;
    //                 }
    //             );
    //         })).then(upload => {

    //             this.saveProduct(data, upload);

    //         });
    //     } else {
    //         this.saveProduct(data);
    //     }
    // } else {
    //     this.toastr.error('Sai kích thước hình ảnh', '', {
    //         timeOut: 4000,
    //         positionClass: 'toast-bottom-right'
    //     });
    // }
  }

  removeInfo(i) {
    this.arrContent.splice(i, 1);
  }

  saveProduct(data, upload: any = []) {
    let product = <any>{};
    product = data;
    product.images = [];
    product.image = this.thumb;

    if (upload.length > 0) {
      if (this.filesThumb) {
        product.image = upload[0].size.thumb_large;
        if (this.files && this.files.length > 0) {
          upload.shift(); // remove thumb
        }
      }
      if (this.files && this.files.length > 0) {
        if (upload.length >= 1) {
          product.images = [];
          upload.forEach((res) => {
            product.images.push(res.size.original);
          });
        }
      }
    }
    if (this.attachments.length > 0) {
      for (let i = 0; i < this.attachments.length; i++) {
        if (this.attachments[i]) {
          product.images.push(this.attachments[i]);
        }
      }
    }
    console.log(111111111111)
    this.productService
      .updateProductById(this.idDetail, product)
      .toPromise()
      .then(
        (res) => {
          if (res) {
            if (res.error) {
              // this.message = {
              //     class: 'alert dark alert-danger',
              //     content: res.status + ' : ' + res.message
              // };
              this.toastr.error(res.status + ' : ' + res.message, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              // this.message = {
              //     class: 'alert dark alert-success',
              //     content: 'Cập nhật thành công'
              // };

              this.toastr.success('Cập nhật sản phẩm thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.backToList.emit({
                isBack: false,
              });
              this.getDetailProduct(this.idDetail);
            }
          }
        },
        (err) => {
          // this.message = { content: err.message, class: 'alert dark alert-danger' };
          this.toastr.error(err.message, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        }
      );
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  // ck editor
  uploadCK(event, idUPload) {
    $('#' + idUPload).click();
  }

  saveToCK(event, yourEditorID) {
    let files: any[] = [];
    var filesAmount = event.target.files.length;
    var ValidImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    for (var i = 0; i < filesAmount; i++) {
      var fileType = event.target.files[i]['type'];
      var fileSize = event.target.files[i]['size'];
      if (fileSize <= 1024 * 1024) {
        if ($.inArray(fileType, ValidImageTypes) > 0) {
          // valid file type code goes here.
          files.push(event.target.files[i]);
        }
      } else {
        $('#' + yourEditorID).html(
          event.target.files[i]['name'] +
          ' có dung lượng quá 1MB. Vui lòng chọn ảnh khác'
        );
      }
    }
    Promise.all(
      files.map((file) => {
        return this.upload.upload(file).then((uploaded: any) => {
          return JSON.parse(uploaded._body).data;
        });
      })
    ).then((upload: any) => {
      upload.forEach((dta) => {
        let html = '<img src=\'' + dta.url + '\'/>';
        (<FormControl>this.productForm.controls[yourEditorID]).setValue(
          this.productForm.controls[yourEditorID].value + '<br/>' + html
        );
      });
    });
  }

  isEmpty(str) {
    return !str || 0 === str.length;
  }

  readUrl(input, message, showImage) {
    this.message = null;
    if (input.target.files) {
      var filesAmount = input.target.files.length;
      $(showImage).html('');
      $(message).html('');
      var ValidImageTypes = [
        'image/gif',
        'image/jpeg',
        'image/png',
        'image/jpg',
      ];
      if (filesAmount <= 20) {
        for (var i = 0; i < filesAmount; i++) {
          var reader = new FileReader();
          var fileType = input.target.files[i]['type'];
          if ($.inArray(fileType, ValidImageTypes) > 0) {
            // valid file type code goes here.
            reader.onload = (event: any) => {
              $(showImage).append(
                '<li><div class="card card-shadow"><figure class="card-img-top overlay-hover overlay"><img class="overlay-figure overlay-scale" src="' +
                event.target.result +
                '" alt="..." style="height: 100px;object-fit: cover;"></figure></div></li>'
              );
            };
            $(message).html('');
          } else {
            $(message).html('');
            $(message).html('Ảnh đại diện phải có định dạng JPG, JPEG và PNG.');
          }
          reader.readAsDataURL(input.target.files[i]);
        }
      } else {
        $(message).html('');
        $(message).html('Bạn chỉ được chọn tối đa 20 ảnh.');
      }
    }
  }

  onChange(event, message, type) {
    this.message = null;
    var mFile = event.target.files;
    var filesAmount = event.target.files.length;
    var ValidImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/jpg'];
    var fileType = event.target.files[0]['type'];
    var fileSize = event.target.files[0]['size'];

    if (filesAmount <= 20) {
      if (fileSize <= 1024 * 1024) {
        if ($.inArray(fileType, ValidImageTypes) > 0) {
          switch (type) {
            case 1: {
              this.filesThumb = null;
              this.filesThumb = mFile[0];
              this.isTrueSize = true;
              break;
            }
            case 2: {
              this.files = [];
              for (let _file of event.target.files) {
                this.files.push(_file);
              }
              this.isTrueSize = true;
              break;
            }
          }
        }
        $(message).html('');
      } else {
        $(message).html('');
        $(message).html(
          'Dung lượng ảnh không được quá 1MB. Vui lòng chọn ảnh khác'
        );
        this.isTrueSize = false;
      }
    } else {
      $(message).html('');
      $(message).html('Bạn chỉ được chọn tối đa 20 ảnh.');
      this.isTrueSize = false;
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  getAttachments() {
    this.filesAttachName = [];
    if (this.product.attachments && this.product.attachments.length > 0) {
      this.product.attachments.forEach((att) => {
        var show = '';
        if (att.length > 30) {
          show = '... ... ' + att.slice(att.length - 20, att.length);
        } else {
          show = att;
        }
        var item = {
          link: att,
          show: show,
          isAdd: false,
        };
        this.filesAttachName.push(item);
      });
    }
  }
  getAttachmentsFake() {
    this.filesAttachNameFake = [];
    if (this.product.fake_attachments && this.product.fake_attachments.length > 0) {
      this.product.fake_attachments.forEach((att) => {
        var show = '';
        if (att.length > 30) {
          show = '... ... ' + att.slice(att.length - 20, att.length);
        } else {
          show = att;
        }
        var item = {
          link: att,
          show: show,
          isAdd: false,
        };
        this.filesAttachNameFake.push(item);
      });
    }
  }

  async uploadFiles() {
    let attach: any = [];
    let attachFake: any = [];
    if (this.filesAttach.length > 0) {
      await Promise.all(
        this.filesAttach.map((attach) => {
          return this.upload
            .uploadFileAttach(attach)
            .then((attached: any) => {
              return JSON.parse(attached._body).data;
            });
        })
      ).then((attached) => {
        attach = attached
      });
    }
    if (this.filesAttachFake.length > 0) {
      await Promise.all(
        this.filesAttachFake.map((attach) => {
          return this.upload
            .uploadFileAttach(attach)
            .then((attached: any) => {
              return JSON.parse(attached._body).data;
            });
        })
      ).then((attached) => {
        attachFake = attached

      });
    }
    return {
      attach: attach,
      attachFake: attachFake
    }
    // ...
  }

  readFileAttach(event) {
    //this.filesAttach = [];
    // this.getAttachments();
    var files = event.srcElement.files;
    //var listFileAttach: any = [];
    var ValidImageTypes = [
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/pdf',
      'image/gif',
      'image/jpeg',
      'image/png',
      'image/jpg',
    ];
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        if (files[i]) {
          if (this.filesAttachName.length > 5) {
            this.toastr.warning(
              'Một sản phẩm chỉ cho phép tải lên tối đa 5 File',
              '',
              {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              }
            );
            return
          }
          if (files[i].size > 5 * 1024 * 1024) {
            this.toastr.warning(
              'Kích thước File' + files[i].name + 'quá lớn',
              '',
              {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              }
            );
            return

          }
          if (ValidImageTypes.indexOf(files[i].type) < 0) {
            this.toastr.warning('File' + files[i].name + ' sai định dạng', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            return

          }

          if (
            ValidImageTypes.indexOf(files[i].type) >= 0 &&
            files[i].size <= 5 * 1024 * 1024 &&
            this.filesAttachName.length < 5
          ) {
            this.filesAttach.push(files[i]);
            let filename = '';
            if (files[i].name.length > 30) {
              filename =
                files[i].name.slice(0, 5) +
                ' ... ... ' +
                files[i].name.slice(
                  files[i].name.length - 9,
                  files[i].name.length
                );
            } else {
              filename = files[i].name;
            }

            var item = {
              link: null,
              show: filename,
              name: files[i].name,
              isAdd: true,
            };
            this.filesAttachName.push(item);
          }

        }
      }
    }
  }

  readFileAttachFake(event) {
    //this.filesAttach = [];
    // this.getAttachments();
    var files = event.srcElement.files;
    //var listFileAttach: any = [];
    var ValidImageTypes = [
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/pdf',
      'image/gif',
      'image/jpeg',
      'image/png',
      'image/jpg',
    ];
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        if (files[i]) {
          if (this.filesAttachNameFake.length > 5) {
            this.toastr.warning(
              'Một sản phẩm chỉ cho phép tải lên tối đa 5 File',
              '',
              {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              }
            );
            return
          }
          if (files[i].size > 5 * 1024 * 1024) {
            this.toastr.warning(
              'Kích thước File' + files[i].name + 'quá lớn',
              '',
              {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              }
            );
            return

          }
          if (ValidImageTypes.indexOf(files[i].type) < 0) {
            this.toastr.warning('File' + files[i].name + ' sai định dạng', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            return

          }
          if (
            ValidImageTypes.indexOf(files[i].type) >= 0 &&
            files[i].size <= 5 * 1024 * 1024 &&
            this.filesAttachNameFake.length < 5
          ) {
            this.filesAttachFake.push(files[i]);
            let filename = '';
            if (files[i].name.length > 30) {
              filename =
                files[i].name.slice(0, 5) +
                ' ... ... ' +
                files[i].name.slice(
                  files[i].name.length - 9,
                  files[i].name.length
                );
            } else {
              filename = files[i].name;
            }

            var item = {
              link: null,
              show: filename,
              name: files[i].name,
              isAdd: true,
            };
            this.filesAttachNameFake.push(item);
          }

        }
      }
    }
  }

  deleteFile(index) {
    var itemIndex = this.filesAttachName[index];
    var found = this.filesAttach.findIndex(function (element) {
      var index;
      if (element.name === itemIndex.name) {
        return element;
      }
    });
    //var indexFile = this.filesAttach.indexOf(found);
    this.filesAttach.splice(found, 1);
    this.filesAttachName.splice(index, 1);
  }

  deleteFileFake(index) {
    let itemIndex = this.filesAttachNameFake[index];
    let found = this.filesAttachFake.findIndex(function (element) {
      let index;
      if (element.name === itemIndex.name) {
        return element;
      }
    });
    //var indexFile = this.filesAttach.indexOf(found);
    this.filesAttachFake.splice(found, 1);
    this.filesAttachNameFake.splice(index, 1);
  }

  changeCountry() {
    if (this.selectedCountry !== '241') {
      this.cities = [];
      this.districts = [];
    } else {
      this.getCity();
    }
  }

  updatePlaceholders() {
    this.translate.get([
      'PT_NHAP_BARCODE_SP',
      'PT_NHAP_THONG_TIN_DN',
      'PT_CHON_QUOC_GIA'
    ]).subscribe((t: any) => {
      this.placeholders = {
        barcode: t['PT_NHAP_BARCODE_SP'],
        vendorDesc: t['PT_NHAP_THONG_TIN_DN'],
        country: t['PT_CHON_QUOC_GIA']
      };
    });
  }

  ngOnDestroy() {
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/product/product_edit.component.ts